<script>
/* global axios */
// Chatwoot kimlik basliklarini AYRI bir axios ornegine koyuyor ve onu
// window.axios olarak yayinliyor. "import axios from axios" ham kutuphaneyi
// getirir, basliklar gitmez ve istek 401 doner. Global ornek kullanilmali.
// WhatsApp'i QR ile baglama ekrani (Baileys).
//
// Akis: gelen kutusu olusturulur -> gecitte oturum baslatilir -> QR gosterilir
// -> telefon okutunca durum "connected" olur -> temsilci atama adimina gecilir.
//
// Telefon numarasi SORULMAZ: QR okununca gercek numara zaten gecitten gelir
// ve sunucu tarafinda yazilir. Kullaniciya sormak hem gereksiz bir adim hem de
// yanlis yazilma riski - yanlis numara gonderimi baska bir hatta gonderirdi.
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const YOKLAMA_ARALIGI_MS = 2500;

export default {
  components: {
    NextButton,
    Spinner,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      adim: 'form',
      inboxName: '',
      inboxId: null,
      qr: null,
      durum: 'starting',
      sonHata: null,
      yoklayici: null,
      olusturuluyor: false,
      baslatilamadi: false,
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags', accountId: 'getCurrentAccountId' }),
    durumMetni() {
      return this.$t(`INBOX_MGMT.ADD.WHATSAPP.BAILEYS.DURUM.${this.durum.toUpperCase()}`);
    },
  },
  validations: {
    inboxName: { required },
  },
  beforeUnmount() {
    this.yoklamayiDurdur();
  },
  methods: {
    yoklamayiDurdur() {
      if (this.yoklayici) {
        clearInterval(this.yoklayici);
        this.yoklayici = null;
      }
    },
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid || this.olusturuluyor) return;

      this.olusturuluyor = true;
      try {
        const kanal = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName?.trim(),
          channel: {
            type: 'whatsapp',
            provider: 'baileys',
            provider_config: {},
          },
        });
        this.inboxId = kanal.id;
        this.adim = 'qr';
        await this.oturumuBaslat();
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.BAILEYS.HATA')
        );
      } finally {
        this.olusturuluyor = false;
      }
    },
    taban() {
      return `/api/v1/accounts/${this.accountId}/baileys/${this.inboxId}`;
    },
    async oturumuBaslat() {
      try {
        const { data } = await axios.post(`${this.taban()}/baslat`);
        this.durumuIsle(data);
        this.baslatilamadi = false;
      } catch (error) {
        // Gecit ulasilamazsa yoklamaya hic baslamayiz: her 2.5 saniyede bir
        // ayni hatayi tekrarlamak yerine durumu acikca soyleyip kullaniciya
        // yarim kalan gelen kutusunu silme secenegi veririz.
        this.sonHata = error.response?.data?.error || error.message;
        this.baslatilamadi = true;
        return;
      }
      this.yoklamayiDurdur();
      this.yoklayici = setInterval(() => this.durumuSorgula(), YOKLAMA_ARALIGI_MS);
    },

    // Baglanti kurulamadiysa olusturulan gelen kutusu ortada kalmasin.
    async vazgec() {
      this.yoklamayiDurdur();
      try {
        await axios.delete(
          `/api/v1/accounts/${this.accountId}/inboxes/${this.inboxId}`
        );
      } catch {
        // Silinemezse de kurulum ekranina donuyoruz; kutu Ayarlar'dan silinebilir.
      }
      this.inboxId = null;
      this.qr = null;
      this.sonHata = null;
      this.baslatilamadi = false;
      this.adim = 'form';
    },
    async durumuSorgula() {
      try {
        const { data } = await axios.get(`${this.taban()}/durum`);
        this.durumuIsle(data);
      } catch (error) {
        this.sonHata = error.message;
      }
    },
    durumuIsle(data) {
      this.durum = data.durum ?? 'starting';
      this.qr = data.qr ?? this.qr;
      this.sonHata = data.sonHata ?? null;

      if (this.durum === 'connected') {
        this.yoklamayiDurdur();
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: this.inboxId },
        });
      }
    },
    async yenile() {
      this.qr = null;
      await this.oturumuBaslat();
    },
  },
};
</script>

<template>
  <form
    v-if="adim === 'form'"
    class="flex flex-col flex-wrap mx-0"
    @submit.prevent="createChannel()"
  >
    <p class="mb-4 text-sm leading-relaxed text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.WHATSAPP.BAILEYS.ACIKLAMA') }}
    </p>

    <div class="flex-grow-0 flex-shrink-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-full">
      <NextButton
        :is-loading="uiFlags.isCreating || olusturuluyor"
        type="submit"
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.BAILEYS.DEVAM')"
      />
    </div>
  </form>

  <div v-else class="flex flex-col items-center gap-4 py-4 text-center">
    <h2 class="text-base font-medium text-n-slate-12">
      {{ $t('INBOX_MGMT.ADD.WHATSAPP.BAILEYS.QR_BASLIK') }}
    </h2>
    <p class="max-w-md text-sm leading-relaxed text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.WHATSAPP.BAILEYS.QR_ADIMLAR') }}
    </p>

    <div
      class="flex items-center justify-center bg-white border rounded-xl border-n-weak size-[320px]"
    >
      <img v-if="qr" :src="qr" alt="WhatsApp QR" class="size-[300px]" />
      <Spinner v-else class="text-n-brand" />
    </div>

    <p class="text-sm text-n-slate-11">{{ durumMetni }}</p>
    <p v-if="sonHata" class="text-sm text-n-ruby-11">{{ sonHata }}</p>

    <div class="flex gap-2">
      <NextButton
        variant="faded"
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.BAILEYS.YENILE')"
        @click="yenile"
      />
      <NextButton
        v-if="baslatilamadi"
        variant="faded"
        color="ruby"
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.BAILEYS.VAZGEC')"
        @click="vazgec"
      />
    </div>
  </div>
</template>
